import { Query, QueryFunction, QueryKey, useQuery } from "@tanstack/react-query"

type RefetchInterval<T> = number | false | ((query: Query<T, Error, T, QueryKey>) => number | false)

type Params<T> = {
  key: QueryKey
  refetchInterval?: RefetchInterval<T>
}

export function useCustomQuery<T>(params: Params<T>, func: QueryFunction<T, QueryKey, never>) {
  const { data, isError, isFetching, isLoading, isRefetching } = useQuery<T, Error>({
    queryKey: params.key,
    queryFn: func,
    refetchInterval: params.refetchInterval,
  })

  return {
    data,
    isError,
    isFetching,
    isLoading,
    isRefetching,
  }
}
